import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { RootWrapper } from "@repo/ping-react-js";
import "./index.scss";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RootWrapper VITE_APP_AUTH_URL={import.meta.env.VITE_APP_AUTH_URL}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </RootWrapper>
  </StrictMode>,
);
